import { useMutation } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

type AcceptInviteData = {
  token: string;
  firstName: string;
  lastName: string;
  password: string;
};

type AcceptInviteResponse = {
  message: string;
};

const acceptInvite = async (
  inviteData: AcceptInviteData
): Promise<AcceptInviteResponse> => {
  const { data } = await customAxios.post<AcceptInviteResponse>(
    '/invites/accept',
    inviteData
  );
  return data;
};

export const useAcceptInvite = () =>
  useMutation({
    mutationFn: acceptInvite,
  });
